// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"45227b6f","598":"aba45a06","703":"36774eec"}[chunkId] + ".chunk.js";
};